/**
 * Up-to-2-char initials for an avatar chip, from name parts or email.
 * Shared by the global SiteHeader and the Dashboard greeting so they never
 * disagree.
 */
export function initialsOf(
  first?: string | null,
  last?: string | null,
  email?: string | null,
): string {
  const f = (first ?? '').trim();
  const l = (last ?? '').trim();
  if (f || l) {
    return ((f[0] ?? '') + (l[0] ?? '')).toUpperCase() || '?';
  }
  const e = (email ?? '').trim();
  return (e[0] ?? '?').toUpperCase();
}
